import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';
import { OpenFeature } from '@openfeature/react-sdk';

const AUTH0_DESKTOP_401_RECOVERY_FLAG_KEY = 'release-apps-auth0-desktop-401-recovery';

/**
 * Gates AUTH0_DESKTOP eligibility for 401 recovery. Off by default. The
 * complete enablement gate list — every one of these must hold before this
 * flag flips on:
 *
 * 1. The outer source-of-truth flag (`release-scribe-auth-source-of-truth`)
 *    must be on. `isRecoveryEligible` checks this flag only inside that
 *    outer gate — this flag alone is inert; the outer flag governs recovery
 *    for every other eligible provider independently of this one.
 * 2. WWW-Authenticate must be recorded as readable cross-origin from the
 *    packaged webview origin — `https://tauri.localhost`, the origin every
 *    platform's main window loads under (the app sets `useHttpsScheme` in
 *    `tauri.conf.json`) — not just the web origin.
 * 3. Cold-boot commit-gate recovery must be proven by a test — a fresh
 *    desktop launch whose first token read races the commit gate must
 *    demonstrably resolve to a working session, not a false unauthenticated
 *    state.
 * 4. Route-level recovery telemetry must be verified in Datadog with
 *    facetable attributes (not buried in an unparsed message string), a
 *    saved rollout query grouped by route, reason, platform, provider and
 *    client, and monitors on the header-missing, transient and logout
 *    routes — all in place before this flag governs real traffic.
 *
 * A plugin-side fix for the refresh-token read's single-flight ordering
 * exists but is on hold for lack of production evidence — revisit it if
 * Auth0 logs show refresh-token reuse rejections for the desktop client.
 */
export const isAuth0Desktop401RecoveryEnabled = () =>
  OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    AUTH0_DESKTOP_401_RECOVERY_FLAG_KEY,
    false
  );
